// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__1EpNS","button":"styles_button__1LEpF","success":"styles_success__3cf3o","danger":"styles_danger__ORwi4"};